export const LOGIN_BASE_PATH = "/login";
export const RESET_PASSWORD_PATH = "/reset-password";
export const START_PATH = "/start";
export const ACCOUNT_PATH = "/account";
export const SECURITY_PATH = "/security";
export const IDENTITY_PATH = "/identity";
export const SIGNUP_BASE_PATH = "/register";
export const CHPASS_BASE_PATH = "/chpass";
